module.exports = __webpack_public_path__ + "img/global__close.6c3cc88b.svg";